import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWithLocale } from '../api';

export const fetchBanners = createAsyncThunk(
  'banner/fetchBanners',
  async ({ position, page }, thunkAPI) => {
    try {
      const response = await fetchWithLocale(`ad?page=${page}&position=${position}`);
      if(response.status === 404) {
        return thunkAPI.rejectWithValue(response.statusText);
      }
      return response;
    } catch (error) {
      //console.log('banner debug fetchBanners error', error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);


const bannerSlice = createSlice({
  name: 'banner',
  initialState: {
    banners: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        //console.log('banner debug fetchBanners pending');
        state.loading = true;
        state.banners = [];
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        //console.log('banner debug fetchBanners fulfilled', action.payload);
        state.loading = false;
        state.banners = action.payload;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        //console.log('banner debug fetchBanners rejected', action.payload);
        state.loading = false;
        state.banners = [];
        state.error = action.payload;
      });
  },
});

export default bannerSlice.reducer;
